export enum Settings {
  SETTLEMENT_REMINDER_ADVANCED_DAYS = 'SETTLEMENT_REMINDER_ADVANCED_DAYS',
}

export interface SettingsData {
  key: Settings;
  value: string;
}
